import { render, staticRenderFns } from "./LinkedOrganizations.vue?vue&type=template&id=485aa0da&scoped=true"
import script from "./LinkedOrganizations.vue?vue&type=script&lang=js"
export * from "./LinkedOrganizations.vue?vue&type=script&lang=js"
import style0 from "./LinkedOrganizations.vue?vue&type=style&index=0&id=485aa0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485aa0da",
  null
  
)

export default component.exports